import { render, staticRenderFns } from "./AddClientModal.vue?vue&type=template&id=2af34515&scoped=true&"
import script from "./AddClientModal.vue?vue&type=script&lang=js&"
export * from "./AddClientModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClientModal.vue?vue&type=style&index=0&id=2af34515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af34515",
  null
  
)

export default component.exports